import {Component, Input} from '@angular/core';
import {Location} from "@angular/common";
import {AuthService} from "../../services/auth/auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent {

  @Input() title: string;
  @Input() enableBackBtn: boolean = false;
  @Input() enableHomeBtn: boolean = false;
  @Input() dbCode: any = null;

  constructor(
    private router: Router,
    private location: Location,
    private authService: AuthService,
  ) {
  }

  onLogout() {
    this.authService.logout();

    this.router.navigate(['/login'])
      .catch(err => console.error(err));
  }

  onHomeClick() {
    this.router.navigate(['/']);
  }
}
